import { useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import {
  unpublishContent as unpublishContentThunk,
  getAllContents,
} from '@store/features/content/contentSlice';

interface UseUnpublishContentResult {
  unpublishContent: (contentId: string) => Promise<void>;
  isLoading: boolean;
  error: Error | null;
}

/**
 * Hook personalizado para manejar la despublicación de contenido
 * @returns Objeto con la función para despublicar contenido y el estado de la operación
 */
export const useUnpublishContent = (): UseUnpublishContentResult => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const dispatch = useAppDispatch();

  const unpublishContent = async (contentId: string): Promise<void> => {
    if (!contentId) {
      console.error('Content ID is undefined or empty');
      setError(new Error('Content ID is undefined or empty'));
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      await dispatch(unpublishContentThunk(contentId)).unwrap();
      dispatch(getAllContents());
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    unpublishContent,
    isLoading,
    error,
  };
};
